var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconizin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_5166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 12C24.0001 11.5953 23.98 11.1953 23.9409 10.8009L18.6046 5.45425L11.0231 3.22192L5.43428 6.53397L3.17664 11.7187L5.38857 18.5387L10.7909 23.9398C11.1885 23.9796 11.5919 24 12.0001 24C18.6275 24 24.0001 18.6274 24.0001 12Z",
    fill: "#FFA300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5115 8.85801V7.19165H12.0152L12.4839 6.52884L12.0152 5.7854H9.10522V10.2643H12.0152L12.4839 9.57107L12.0152 8.85801H10.5115Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8947 5.7854H11.9833V7.19165H13.4884V8.85801H11.9833V10.2643H14.8947V5.7854Z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0459 11.6351V16.4671H12.0152L12.4839 13.9799L12.0152 11.6351H6.0459Z",
    fill: "#D79B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9833 11.6351H17.9541V16.4671H11.9833V11.6351Z",
    fill: "#B46E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0459 8.04004V11.8124H12.0152L12.4839 9.92624L12.0152 8.04004H6.0459Z",
    fill: "#C38778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9833 8.04004H17.9541V11.8125H11.9833V8.04004Z",
    fill: "#A65D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40332 11.0028H8.89995V12.6827H7.40332V11.0028Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1001 11.0028H16.5967V12.6827H15.1001V11.0028Z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.8968C10.0754 19.8968 8.30948 19.2047 6.93787 18.0564L12.0152 12.9791L12.4839 11.8125L12.0152 10.9904L5.94351 17.0621C4.79521 15.6905 4.10315 13.9245 4.10315 11.9999C4.10315 7.64563 7.64568 4.1031 12 4.1031C12.0051 4.1031 12.0101 4.10324 12.0152 4.10329L12.4839 3.34987L12.0152 2.69709C12.0101 2.69709 12.0051 2.6969 12 2.6969C6.87023 2.69685 2.6969 6.87018 2.6969 11.9999C2.6969 17.1297 6.87023 21.303 12 21.303C12.0051 21.303 12.0101 21.3029 12.0152 21.3029L12.4839 20.6052L12.0152 19.8966C12.0101 19.8966 12.0051 19.8968 12 19.8968Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.6969V4.10315C13.9245 4.10315 15.6905 4.79521 17.0621 5.94351L11.9833 11.0223V13.011L18.0564 6.93792C19.2047 8.30952 19.8968 10.0755 19.8968 12C19.8968 16.3544 16.3543 19.8969 12 19.8969V21.3031C17.1297 21.3031 21.3031 17.1298 21.3031 12C21.3031 6.87028 17.1297 2.6969 12 2.6969Z",
    fill: "#414952"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_5166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconizin);
export default __webpack_public_path__ + "static/media/iconizin.9e47cd4db5cedd0e5fb90ffb1651dded.svg";
export { ForwardRef as ReactComponent };